export default "ui-toggle-tabbar{flex:auto !important;display:inline-flex;height:100%;overflow:hidden;overflow-x:auto}\n";